/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HomeAliases {
  APPLICATION_BAR = 'application-bar',
  AVATAR = 'avatar',
  DROP_DOWN_MENU_USER = 'drop-down-menu-user',
  FETCH_NOTIFICATION = 'fetch-notification',
  FOOTER_0 = 'footer-0',
  FRAGMENT_ACCREDITATION = 'fragment-accreditation',
  FRAGMENT_NEGOTIATION_DRAFT = 'fragment-negotiation-draft',
  FRAGMENT_NEGOTIATION_TABCONTROL = 'fragment-negotiation-tabcontrol',
  FRAGMENT_ROUTES = 'fragment-routes',
  FRAGMENT_TECHNICAL_VISIT_APPOINTMENTS = 'fragment-technical-visit-appointments',
  FRAGMENT_TECHNICAL_VISIT_FORMS = 'fragment-technical-visit-forms',
  FRAGMENT_TECHNICAL_VISIT_INCONSISTENCIES = 'fragment-technical-visit-inconsistencies',
  LAYOUT_PROVIDER_ACCREDITATION = 'layout-provider-accreditation',
  NOTIFICATION_CENTER = 'notification-center',
  OPTION_EXIT = 'option-exit',
  OPTION_MY_DATA = 'option-my-data',
  PANEL_ACCREDITATION = 'panel-accreditation',
  PANEL_APP_ROUTES = 'panel-app-routes',
  PANEL_NOTIFICATION = 'panel-notification',
  PANEL_ROUTES = 'panel-routes',
  ROUTE_ACCREDITATION = 'route-accreditation',
  ROUTE_NEGOTIATION_DRAFT = 'route-negotiation-draft',
  ROUTE_NEGOTIATION_TABCONTROL = 'route-negotiation-tabcontrol',
  ROUTE_ROUTES = 'route-routes',
  ROUTE_TECHNICAL_VISIT_APPOINTMENTS = 'route-technical-visit-appointments',
  ROUTE_TECHNICAL_VISIT_FORMS = 'route-technical-visit-forms',
  ROUTE_TECHNICAL_VISIT_INCONSISTENCIES = 'route-technical-visit-inconsistencies',
}
export { HomeAliases };
